// cspell:words setname
import manageSchema from '../model/schema';
import { assertOk, takeData } from '../../misc/api-utils';
import { urlApiFactory } from '../model/factory';
import { emptyArray } from '../../misc';

export const PATHNAME = '/api/modules/GetResources';

export const schema = manageSchema
  .pick({
    hostApi: true,
    eventId: true,
  })
  .required();

const applyDefault = (data) => (data === null ? emptyArray : data);

export const fetchGet = (params) => async () => {
  const prms = schema.parse(params);

  const url = urlApiFactory(prms);
  url.pathname = PATHNAME;
  url.searchParams.append('eventId', prms.eventId);
  url.searchParams.append('setname', 'config_json');

  const req = new Request(url);
  return fetch(req)
    .then(assertOk)
    .then(takeData)
    .then(applyDefault);
};
